((Copyright, $) => {
  'use strict';

  let $copyright;

  const cacheDom = () => {
    $copyright = $('.copyright-to-year');
  };

  const updateYear = () => {
    const date = new Date();
    const year = date.getFullYear();
    $copyright.text(year);
  };

  const init = () => {
    cacheDom();
    updateYear();
  };

  Copyright.init = init;
})(window.Copyright = window.Copyright || {}, jQuery);
